import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getAssessmentResultByAssessmentAttemptId } from "../plan/actions";
import {
  getAssessmentAttemptByUserId,
  getAssessment,
  shareReportOnEmail,
  deleteReport,
  getInsightfulContent,
  sendToFriendReportOnEmail,
  sendToPartnerReportOnEmail,
  isCompleteRomanticCompatibility,
  getUserAssessmentResultMapByUserId,
  getUserAssessmentResultByResultId,
  getBadges,
  saveUserSocialButtonClick,
  getUserSocialButtonClickByUserId,
} from "./actions";
import { downloadAssessmentResult } from "../confirmation/actions";
import {
  createGuestUser,
  getBilling,
  getGuestUser,
  getTransactionDetail,
  GetUserById,
  isGuestOrPremiumUser,
} from "../settings/actions";
import DashboardB from "./component";

const mapStateToProps = ({ funnelStep }) => ({
  funnelStep,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAssessmentResultByAssessmentAttemptIdConnect:
        getAssessmentResultByAssessmentAttemptId,
      getAssessmentAttemptByUserIdConnect: getAssessmentAttemptByUserId,
      getAssessmentByIdConnect: getAssessment,
      DownloadAssessmentResultConnect: downloadAssessmentResult,
      GetUserByIdConnect: GetUserById,
      IsGuestOrPremiumUserConnect: isGuestOrPremiumUser,
      ShareReportOnEmailConnect: shareReportOnEmail,
      DeleteReport: deleteReport,
      GetGuestUserConnect: getGuestUser,
      GetTransactionDetailConnect: getTransactionDetail,
      GetBillingConnect: getBilling,
      GuestUserChangesConnect: createGuestUser,
      getInsightfulContentConnect: getInsightfulContent,
      sendToFriendReportOnEmailConnect: sendToFriendReportOnEmail,
      sendToPartnerReportOnEmailConnect: sendToPartnerReportOnEmail,
      isCompleteRomanticCompatibilityConnect: isCompleteRomanticCompatibility,
      getUserAssessmentResultMapByUserIdConnect:
        getUserAssessmentResultMapByUserId,
      getUserAssessmentResultByResultIdConnect:
        getUserAssessmentResultByResultId,
      getBadgesConnect: getBadges,
      saveUserSocialButtonClickConnect: saveUserSocialButtonClick,
      getUserSocialButtonClickByUserIdConnect: getUserSocialButtonClickByUserId,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(DashboardB);
